import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMultiPromptData,
  BackendMutationCreateMultiPromptBlocksArgs,
} from 'src/types/backend';

import { FRAGMENT_MULTI_PROMPT_DATA } from './schema';

const MUTATION = gql`
  mutation CreateMultiPromptBlocks(
    $customerId: ID!
    $description: String!
    $inputFields: [JSON!]!
    $toolList: JSON!
    $generationTool: GenerationToolEnum
    $allInstructionsData: JSON
    $urlExtractions: [UrlExtractionInput!]
    $title: String
    $length: Int
    $moreInfo: JSON
    $projectId: ID
  ) {
    createMultiPromptBlocks(
      customerId: $customerId
      description: $description
      inputFields: $inputFields
      toolList: $toolList
      generationTool: $generationTool
      allInstructionsData: $allInstructionsData
      urlExtractions: $urlExtractions
      title: $title
      length: $length
      moreInfo: $moreInfo
      projectId: $projectId
    ) {
      ...MultiPromptData
    }
  }
  ${FRAGMENT_MULTI_PROMPT_DATA}
`;

type Variables = BackendMutationCreateMultiPromptBlocksArgs;
type Result = BackendMultiPromptData;

export const createMultiPromptBlocks = async (variables: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
